import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CheckboxTreeFilterOption} from "../checkbox-tree-filter-option";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store";
import {getFilterByKey} from "../../../store/selectors/filter.selector";
import {IconFont} from "../../../enums/icon-font";

@Component({
  selector: 'brt-checkbox-tree-filter-group',
  templateUrl: './checkbox-tree-filter-group.component.html',
  styleUrls: ['./checkbox-tree-filter-group.component.scss']
})
export class CheckboxTreeFilterGroupComponent {
  @Input("option") set setOption(val: CheckboxTreeFilterOption) {
    this.option = val;
    this.hasChildren = val.children.length > 0;
    // console.warn(this.option);
    if(this.option.partiallySelected) this.checkIcon = 'reg-minus';
    else this.checkIcon = 'check';
  }

  @Output("toggleOption") toggleOption = new EventEmitter<CheckboxTreeFilterOption>();

  option!: CheckboxTreeFilterOption;
  hasChildren = false;

  checkIcon: IconFont = 'check';


  onToggleCheckbox(option: CheckboxTreeFilterOption) {
    this.toggleOption.emit(option);
  }
}
